import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { Button } from '../../../buttons/Button'

import { RemainingMinutesWidget } from '../../../../types/widget/widget'
import { formatMinutes } from '../../../../utils/booking/booking'

type RemainingMinutesProps = {
  minutes: RemainingMinutesWidget | null
}
export const remainingMinutesProgress = (minutes: RemainingMinutesWidget) => {
  if (!Number.isFinite(minutes.activePassesNumber) || minutes.activePassesNumber <= 0) {
    return null
  }

  const total = Math.max(0, minutes.totalMinutes)
  const available = Math.min(total, Math.max(0, minutes.availableMinutes))
  const pct = total > 0 ? Math.round((available / total) * 100) : 0

  return { total, available, pct }
}

export const RemainingMinutes = ({ minutes }: RemainingMinutesProps) => {
  const { t } = useTranslation('dashboard')
  const navigate = useNavigate()

  const progress = minutes ? remainingMinutesProgress(minutes) : null

  if (!minutes || !progress) {
    return (
      <div className="remaining-sessions">
        <div className="remaining-sessions-header">
          <div className="eyebrow remaining-sessions-eyebrow">
            {t('dashboard.remaining-minutes.active-passes', { count: 0 })}
          </div>
          <h3 className="remaining-sessions-title">{t('dashboard.remaining-minutes.title')}</h3>
        </div>
        <div className="remaining-sessions-empty">
          {t('dashboard.remaining-minutes.no-active-pass')}
          <div className="mt-8">
            <Button label={t('dashboard.remaining-minutes.buy')} size="sm" onClick={() => navigate('/passes')} />
          </div>
        </div>
      </div>
    )
  }

  const { total, available, pct } = progress

  return (
    <div className="remaining-sessions">
      <div className="remaining-sessions-header">
        <div className="eyebrow remaining-sessions-eyebrow">
          {t('dashboard.remaining-minutes.active-passes', { count: minutes.activePassesNumber })}
        </div>
        <h3 className="remaining-sessions-title">{t('dashboard.remaining-minutes.title')}</h3>
      </div>
      <div className="remaining-sessions-count">
        <span className="display remaining-sessions-remaining">{formatMinutes(available)}</span>
        <span className="remaining-sessions-label">
          {t('dashboard.remaining-minutes.left', { total: formatMinutes(total) })}
        </span>
      </div>
      <div className="remaining-sessions-bar">
        <div className="remaining-sessions-fill" style={{ width: `${pct}%` }} />
      </div>
      <div className="remaining-sessions-footer">
        <span className="mono">
          {available}/{total} min
        </span>
      </div>
    </div>
  )
}
